<template>
  <div class="style-module" :style="{ textShadow: isTextShadow ? '0px 0px 4px rgba(0, 0, 0, 0.6)' : ''}">
    <div class="style-module-bg" v-if="bgSelect">
      <img :src="getBg" />
    </div>
    <div class="style-module-item" v-for="item in dataInfo" :key="item.id" :style="{
      width: `${item.w}px`,
      height: `${item.h}px`,
      left: `${item.x}px`,
      top: `${item.y}px`
    }">
    <template v-if="item.type === 'text'">
      <richTextView v-if="item.info.functionParms !== undefined" :html="getText(item.info.text, item.info.functionParms)" />
        <div v-else :style="item.info.fontStyle">{{ item.info.text }}</div>
      </template>
      <template v-else-if="item.type === 'img'">
        <el-image v-if="imgSrc[item.id]" :style="isRadius(item.info)" fit="fill" :src="imgSrc[item.id]">
          <template #error>
            <div class="image-slot">
              <img src="https://bigdata.topeti.com/PCRepository/middleground/avatar/23.jpg" alt="">
            </div>
          </template>
        </el-image>
      </template>
      <template v-else-if="item.type === 'weather'">
        <weatherComp />
      </template>
      <template v-else-if="item.type === 'button'">
        <buttonComp class="style-btn" 
          :info="{ info: item.info, i: item.id  }" 
          @to-nav="$emit('to-nav', $event)" 
          @open-ability="$emit('open-ability', $event)" 
          @open-dictionary="$emit('open-dictionary', info)"
          @openAppInitiate="$emit('openAppInitiate', $event)"
          @open-appDialog="openAppDialog"
          @custom-scene="$emit('custom-scene', $event)"
        />
      </template>
      <template v-else-if="item.type === 'icon'">
        <icon-module :config="item.info"></icon-module>
      </template>
    </div>
    <app-dialog 
      :dialogInfo="dialogInfo"
    />
  </div>
</template>

<script>
import { dealText } from '@/api/common.js'
import { getuserbindmsg } from '@/port/clientSide/multipleChoice.js'
import iconMixins from '@/components/common/icon/common.js'
import buttonComp from '@/components/schoolInstrument/component/mutual/component/button/index.vue'
import { cloneDeep } from 'lodash';
import { getCustomVal } from '@/util/customData.js'
import { defineAsyncComponent } from 'vue';
export default {
  // 组件名称
  name: 'styleModule',
  // 组件参数 接收来自父组件的数据
  props: {
    dataInfo: {
      type: Array,
      default: () => ([])
    },
    isTextShadow: {
      type: Boolean,
      default: false
    },
    bgSelect: {
      type: String,
      default: ''
    },
    curNum: {
      type: Number,
      default: 0
    },
    customDeskId: {
      type: [Number, String],
      default: 0
    },
    parentCustomData: {
      type: Array,
    }
  },
  mixins: [iconMixins],
  // 局部注册的组件
  components: {
    buttonComp,
    weatherComp: defineAsyncComponent(() => import('./weather')),
    richTextView: defineAsyncComponent(() => import('@/components/common/richTextView.vue')),
    AppDialog:  defineAsyncComponent(() => import('@/components/schoolInstrument/mixins/AppDialog.vue')),
  },
  // 组件状态值
  data () {
    return {
      imgSrc: {},
      dialogInfo: {
        dialogName: '',
        isVisible: false,
        dialogWidth: '80%',
        dialogHeight: '85vh',
        openType: 'dialog',
        customSize: 65,
        dialogUrl: '',
        diaSize: '80%',
      },
    }
  },
  // 计算属性
  computed: {
    getBg() {
      const bgSelect = this.bgSelect
      if (bgSelect.includes('img-')) {
        return this.$imgurl + bgSelect
      } else if (bgSelect) {
        return 'https://bigdata.topeti.com/PCRepository/middleground/home/icon/' + bgSelect
      } else {
        return ''
      }
    },
    customData() {
      if (this.parentCustomData) {
        return this.parentCustomData
      } else {
        return this.$store.state.doorCustomDataObj[this.customDeskId] || this.$store.state.doorCustomData
      }
    }
  },
  // 侦听器
  watch: {
    dataInfo: {
      handler (val) {
        if (Array.isArray(val) && val.length > 0) {
          for (const item of val) {
            this.getImgUrl(item.info).then(url => {
              this.imgSrc[item.id] = url
            })
          }
        }
      },
      deep: true,
      immediate: true
    }
  },
  // 组件方法
  methods: {
    openAppDialog(val) {
      this.$set(this, 'dialogInfo', val)
    },
    // 图片圆角
    isRadius (info) {
      const style = {
        borderRadius: '',
        width: '100%',
        height: '100%'
      }
      if (info.parms && info.parms.imageShape !== undefined) {
        if (info.parms.imageShape === 1) {
          style.borderRadius = '50%'
        }
      }
      return style
    },
    getText(text, functionParms) {
      const commonData = Object.assign(this.$store.state.userData, { '当前个数': this.curNum })
      
      const res = dealText({ 
        text, 
        commonData, 
        customData: this.customData, 
        functionParms
      })
      return res || text
    },
    async getImgUrl (info) {
      let url = info.url
      // 存在变量就使用变量
      if (info.parms) {
        let user = {}
        const _parms = info.parms
        if (_parms.name === '当前用户') {
          if (this.$store.state.userData) {
            user = cloneDeep(this.$store.state.userData)
          }
        } else {
          const val = getCustomVal(_parms, this.customData) || []
          if (Array.isArray(val) && val.length > 0 && val[0].userId) {
            const res = await getuserbindmsg({ userId: val[0].userId })
            if (res.code === 0 && res.data) {
              user = res.data
            }
          }
        }
        if (_parms.userValue === 'facephotos' && Array.isArray(user[_parms.userValue])) {
          const userMsg = JSON.parse(localStorage.getItem('user'))
          const token = userMsg.accesstoken
          url = user[_parms.userValue][0] ? user[_parms.userValue][0].faceUrl : ''
          url = url.replace('userfiles', 'confiles') + '?accesstoken=' +  token
        } else {
          url = user[_parms.userValue]
        }
        if (url && (url.includes('img-')|| _parms.userValue !== 'avatar')) {
          return this.$imgurl + url
        } else {
          if (url) {
            const list = url.split('/')
            const num = list[list.length - 1]
            let format = `${num}.jpg`
            if (Number(num) >= 36) {
              format = `${num}.svg`
            }
            return `https://bigdata.topeti.com/PCRepository/middleground/avatar/${format}`
          } else {
            if (user && user.sex && user.sex === '女') {
              return 'https://bigdata.topeti.com/PCRepository/middleground/avatar/16.jpg'
            } else {
              return 'https://bigdata.topeti.com/PCRepository/middleground/avatar/23.jpg'
            }
          }
        }
      }
      return this.$imgurl + url
    }
  }
}
</script>

<style scoped lang="scss">
.style-module {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 9999;
  .image-slot {
    width: 100%;
    height: 100%;
    img {
      width: 100%;
      height: 100%;
    }
  }
  &-bg {
    width: 100%;
    height: 100%;
    position: absolute;
    inset: 0;
    z-index: 1;
    overflow: hidden;
    img {
      width: 100%;
    }
  }
  &-item {
    position: absolute;
    z-index: 2;
    ::v-deep .rich-text {
      padding: 0 !important;
      text-align: center;
    }
    .style-btn {
      .btn-one {
        width: 100%;
      }
      .btn-five {
        width: 100%;
      }
      .btn-popover {
        height: 100%;
      }
    }
  }
}
</style>